"use client";

import React from "react";
import { Award, Vault, Heart } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const commitments = [{
  title: "Standard Diplomatici",
  description: "Operiamo con il massimo rigore istituzionale per garantire che ogni pratica rifletta l'eccellenza e l'affidabilità del nostro studio.",
  icon: Award
}, {
  title: "Soluzioni Su Misura",
  description: "Ogni caso di mobilità internazionale è unico. Sviluppiamo strategie personalizzate per aziende, studenti e professionisti globali.",
  icon: Vault
}, {
  title: "Presenza Nazionale",
  description: "Presenza Nazionale, gestiamo le tue pratiche e richieste in tutto il territorio nazionale, aggendo con tempestività ed efficacia in ogni provincia.",
  icon: Heart
}];
const partners = [{
  name: "Global Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/commm.png",
  subtitle: "Consulenza Istituzionale"
}, {
  name: "Global Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/avvv.png",
  subtitle: "Supporto Legale"
}, {
  name: "Global Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/notai.png",
  subtitle: "Servizi Notarili"
}, {
  name: "Global Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/viaggi.png",
  subtitle: "Logistica Globale"
}, {
  name: "Global Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/tradm.png",
  subtitle: "Traduzioni Giurate"
}, {
  name: "Global Partner",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/assi.png",
  subtitle: "Coperture Assicurative"
}];
export default function OurCommitment() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: partnerHeaderRef,
    isVisible: isPartnerHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: partnerContainerRef,
    isVisible: isPartnerContainerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="226878" id="eccellenza-istituzionale" className="bg-background text-foreground py-12 md:py-16 overflow-hidden relative">
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center opacity-[0.03]">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/corporate_seal_watermark.png" alt="" className="w-[1200px] h-[1200px] object-contain" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-primary mb-6 tracking-tight">
            Eccellenza Istituzionale
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default font-light">
            Da 15 anni, WORLD IMMIGRATION DI DELGADO è il punto di riferimento nella mobilità internazionale: autorevolezza, rigore professionale ed eccellenza al servizio del cliente.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mb-16">
          {commitments.map((item, i) => {
          const Icon = item.icon;
          const {
            ref: cardRef,
            isVisible: isCardVisible
          } = useRevealOnScroll({
            threshold: 0.2
          });
          return <div data-index={i} key={i} ref={cardRef} className={`transition-all duration-1000 ease-out ${isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="group relative h-full bg-white backdrop-blur-md border border-white/10 shadow-lg shadow-secondary/5 hover:shadow-xl hover:shadow-secondary/20 transition-all duration-300 text-center flex flex-col items-center pt-10 pb-6 px-4 rounded-lg overflow-hidden before:absolute before:inset-0 before:p-[1px] before:bg-gradient-to-r before:from-transparent before:via-secondary/50 before:to-transparent before:opacity-0 hover:before:opacity-100 before:transition-opacity before:duration-500 before:[mask-image:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[mask-composite:xor] before:pointer-events-none">
                  <CardHeader className="items-center pb-4 w-full relative z-10">
                    <div className="mb-6 p-4 rounded-lg bg-secondary/10 ring-1 ring-secondary/30 transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3">
                      <Icon className="w-8 h-8 text-secondary transition-all duration-500 group-hover:animate-bounce" strokeWidth={1} />
                    </div>
                    <CardTitle className="font-default font-bold text-xl md:text-2xl text-primary tracking-tight">
                      {item.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow flex items-start justify-center w-full relative z-10">
                    <CardDescription className="text-base text-muted-foreground font-default font-normal leading-relaxed max-w-[280px]">
                      {item.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className="mt-20">
          <div ref={partnerHeaderRef} className={`text-center mb-10 transition-all duration-1000 ease-out ${isPartnerHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h3 className="text-xl md:text-2xl font-default font-semibold text-primary mb-4 tracking-[0.15em] uppercase">
              Collaborazioni Nazionali e Internazionali
            </h3>
            <div className="w-32 h-1 bg-gradient-to-r from-[#D4AF37] to-transparent mx-auto rounded-lg" />
          </div>

          <div ref={partnerContainerRef} className="flex flex-nowrap justify-center gap-4 md:gap-6 overflow-x-auto pb-4 lg:overflow-visible">
            {partners.map((partner, i) => {
            const {
              ref: logoRef,
              isVisible: isLogoVisible
            } = useRevealOnScroll({
              threshold: 0.1
            });
            return <div key={i} data-index={i} ref={logoRef} className={`w-[280px] sm:w-[calc(33.33%-1rem)] lg:w-[calc(16.66%-1.5rem)] flex-shrink-0 transition-all duration-700 ease-out ${isLogoVisible ? "animate-[card-entrance_0.8s_ease-out_forwards]" : "opacity-0"}`} style={{
              animationDelay: `${i * 150}ms`
            }}>
                  <Card className="group h-full bg-white/5 backdrop-blur-md border border-white/10 hover:border-[#D4AF37]/50 transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl hover:shadow-[#D4AF37]/10 rounded-lg overflow-hidden flex flex-col items-center p-4 cursor-pointer">
                    <div className="relative mb-3 flex items-center justify-center h-16 w-full">
                      <img src={partner.logo} alt={partner.name} className="h-12 w-auto object-contain transition-all duration-500 group-hover:animate-[logo-glow_2s_infinite_ease-in-out]" loading="lazy" />
                    </div>
                    <div className="text-center">
                      <p className="text-xs font-default font-semibold text-[#D4AF37] uppercase tracking-widest mb-1">
                        {partner.name}
                      </p>
                      <p className="text-[10px] text-muted-foreground font-default font-light uppercase tracking-tighter">
                        {partner.subtitle}
                      </p>
                    </div>
                  </Card>
                </div>;
          })}
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes logo-glow {
          0%, 100% { filter: drop-shadow(0 0 2px rgba(212, 175, 55, 0)); }
          50% { filter: drop-shadow(0 0 12px rgba(212, 175, 55, 0.6)); }
        }
        @keyframes card-entrance {
          from {
            opacity: 0;
            transform: translateY(30px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        .hover-depth {
          transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }
      `
    }} />
    </section>;
}